'use client';

import { c as _c } from "react/compiler-runtime";
import { Columns3, ExternalLink } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';
import Button from '../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../HOC/Modal';
type Props = {
  spaceSlug: string;
};
const BoardBadge = t0 => {
  const $ = _c(6);
  const {
    spaceSlug
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <button type="button" onClick={e => {
      e.stopPropagation();
      setOpen(true);
    }} className="rounded-full bg-yellow-500/20 px-2 py-0.5 text-xs font-emphasis text-yellow-600 transition-colors hover:bg-yellow-500/30 dark:text-yellow-500">board</button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== open || $[2] !== spaceSlug) {
    t2 = open && <Modal closeHandler={() => setOpen(false)}><ModalHeader closeHandler={() => setOpen(false)}><div className="flex items-center gap-2"><Columns3 className="text-yellow-500" /><h2 className="text-xl font-semibold">Board Post</h2></div></ModalHeader><ModalContent><div className="space-y-4 py-2"><p className="text-textSecondary">This post lives on a Board — a workspace where posts are organized into draggable columns and cards, similar to Trello.</p><div className="flex items-start gap-3"><Columns3 className="mt-1 shrink-0 text-yellow-500" size={20} /><div><h3 className="font-semibold">Organized Workflow</h3><p className="text-sm text-textSecondary">Board posts can be moved between columns, reordered, and assigned to team members for structured project management.</p></div></div></div></ModalContent><ModalFooter><Link href={`/s/${spaceSlug}`} onClick={_temp}><Button text="Visit Board" icon={<ExternalLink size={16} />} /></Link></ModalFooter></Modal>;
    $[1] = open;
    $[2] = spaceSlug;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default BoardBadge;
function _temp(e_0) {
  return e_0.stopPropagation();
}